<template>
  <div class="page-content">
    <!-- 筛选 -->
    <div class="screening">
      <div class="search-input">
        <nut-icon size="15px" color="#999999" type="search"></nut-icon>
        <input type="text" v-model="school_name" @keyup.enter="submit" placeholder="请输入您想报名的驾校" />
        <div @click="clearInput" class="search-input-icon">
          <nut-icon size="15px" v-if="school_name" type="circle-cross"></nut-icon>
        </div>
      </div>

      <!--			<nut-searchbar-->
      <!--					:hasIcon="true"-->
      <!--          ref="searchbar"-->
      <!--					placeText="请输入您想报名的驾校"-->
      <!--					v-model="school_name"-->
      <!--					:hasSearchButton="false"-->
      <!--					customClass="search-input"-->
      <!--					:searchIconSize="'14'"-->
      <!--					:searchIconColor="'#999'"-->
      <!--					@submit="search_school"-->
      <!--          @clear="clear"-->
      <!--			></nut-searchbar>-->
      <div class="tabs">
        <template v-for="(item, index) in listTypeData">
          <span
            :class="{'active': listTypeIndex === index}"
            :key="item.id"
            @click="switchTab(index)"
          >{{ item.text }}</span>
        </template>
      </div>
    </div>
    <!-- 列表 -->
    <div class="lists">
      <nut-infiniteloading
      :is-show-mod="true"
        :has-more="isHasMore"
        :is-loading="isLoading"
        :unload-more-txt="'没有更多了'"
        @loadmore="onInfinite"
      >
          <div v-if="schoolList && schoolList.length > 0">
              <div
                class="list"
                @click="routerToDetail(item.store_id)"
                v-for="item in schoolList"
                :key="'index_'+item.store_id"
              >
                <SchoolItem :width="'120px'" :height="'90px'" :store-detail="item"></SchoolItem>
              </div>
            </div>
            <div v-else>
              <empty></empty>
          </div>

          <div class="advertising" @click="$router.push({ path: '/FindDriving' })">
            <img src="../../assets/images/advertising_img.png" alt="领红包" />
            <div class="content">
              <div class="question">找驾校有困难？</div>
              <div class="anwser">车之驭帮你推荐合适的驾校</div>
            </div>
            <div class="btn" >立即体验</div>
          </div>

      </nut-infiniteloading>
    </div>
  </div>
</template>

<script>
import SchoolItem from "@/components/SchoolItem";
import empty from "@/views/Empty";

let timer;
export default {
  name: "StList",
  components: { SchoolItem, empty },
  data() {
    return {
      listTypeData: [
        { text: "推荐", id: 1 },
        // { text: '距离', id: 2 },
        { text: "价格", id: 3 },
        { text: "足迹", id: 4 },
      ], //筛选类型数据
      listTypeIndex: 0, //筛选类型下标
      isHasMore: true, //是否有更多数据可以分页滚动
      isLoading: false, //是否展示加载中动画
      schoolList: [],
      school_name: "",
      page: 1,
    };
  },
  created() {
    this.getSchoolList();
  },
  mounted() {
    window.document.title='驾校列表'
    setTimeout(()=>{
      window.document.title='驾校列表'
    },1500);
    setTimeout(()=>{
      window.document.title='驾校列表'
    },3000);
  },
  methods: {
    /**
     * 筛选类型切换
     * @param {number} index - 下标
     */
    switchTab(index) {
      this.listTypeIndex = index;
      this.page = 1;
      this.schoolList = [];
      this.getSchoolList();
    },
    // 分页请求
    onInfinite() {
      this.isLoading = true;
      this.page++;
      this.getSchoolList();
    },
    /**
     * 跳转驾校详情
     * @param {number} id - 驾校id
     */
    routerToDetail(id) {
      this.$router.push({ name: "StDetail", query: { id: id } });
    },
    getSchoolList() {
      this.$ajax
        .get("/m/getlist/store_list", {
          activity_id: this.$ajax.get_activity_id(),
          type: this.listTypeIndex,
          store_name: this.school_name,
          page: this.page,
        })
        .then((res) => {
          if (this.page == 1 && res.length < 15) {
            this.isHasMore = false;
          } else if (this.page > 1 && res.length < 10) {
            this.isHasMore = false;
          } else {
            this.isHasMore = true;
          }

          if (res.length > 0 || this.schoolList.length > 0) {
            this.schoolList = this.schoolList.concat(res);
          } else {
            this.schoolList = res;
          }
          this.isLoading = false;
        });
    },
    submit() {
      this.schoolList = [];
      this.getSchoolList();
    },
    clearInput() {
      this.school_name = "";
      this.getSchoolList();
    },
  },
};
</script>

<style lang="less" scoped>
.page-content {
  width: 100%;

  .screening {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 10px 15px;
    border-bottom: 1px #e2e2e2 solid;

    .search-input {
      width: 100%;
      height: 30px;
      align-items: center;
      background-color: #f6f6f6;
      border-radius: 20px;
      padding: 0 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;

      input {
        border: none;
        outline: none;
        flex: 1;
        height: 30px;
        background-color: #f6f6f6;
        padding-left: 15px;
        padding-right: 15px;
      }
      .search-input-icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .tabs {
      display: flex;
      align-items: center;

      span {
        font-size: 14px;
        color: #999;
        margin-right: 30px;
      }

      .active {
        font-weight: bold;
        color: #333;
      }
    }
  }

  .lists {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;

    .list {
      box-sizing: border-box;
      padding: 10px 0;
      border-bottom: 1px #e2e2e2 solid;
      margin: 0px 0;
    }

    .advertising {
      width: 100%;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px #e2e2e2 solid;

      img {
        width: 94px;
        height: 80px;
      }

      .content {
        flex: 1;
        color: #333;
        margin-left: 10px;

        .question {
          font-size: 15px;
          font-weight: bold;
        }

        .anwser {
          font-size: 13px;
          margin-top: 5px;
        }
      }

      .btn {
        width: 68px;
        height: 30px;
        background: linear-gradient(
          204deg,
          rgba(0, 194, 255, 1) 0%,
          rgba(60, 67, 236, 1) 100%
        );
        border-radius: 15px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #fff;
      }
    }

    .no-more-data {
      width: 100%;
      margin: 20px 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      .line-left {
        width: 30px;
        height: 1px;
        background: linear-gradient(
          90deg,
          rgba(153, 153, 153, 0) 0%,
          rgba(153, 153, 153, 1) 100%
        );
      }

      span {
        font-size: 12px;
        color: #999;
        margin: 0 10px;
      }

      .line-right {
        width: 30px;
        height: 1px;
        background: linear-gradient(
          270deg,
          rgba(153, 153, 153, 0) 0%,
          rgba(153, 153, 153, 1) 100%
        );
      }
    }
  }
}

/deep/ .nut-searchbar .search-input {
  margin-right: 0;
}
</style>
